import script from "./MobHpControls.vue?vue&type=script&setup=true&lang=js"
export * from "./MobHpControls.vue?vue&type=script&setup=true&lang=js"

import "./MobHpControls.vue?vue&type=style&index=0&id=86a73d36&lang=css"

const __exports__ = script;

export default __exports__